import { IconStarSolid } from '@croquiscom-pvt/zds';
import { Badge } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import { themeTokens } from '@croquiscom-pvt/zds/tokens/zigzag';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { white } from '@common/styles';
import { PDPCustomAttributeKeys } from '@common/test-automation';
import { BaseText } from '@common/toolbox';
import { numberWithPlusSignByMaxCount } from '@common/utils';

interface ReviewButtonProps {
  total_count: number;
  has_review_event: boolean;
  review_prediction_rating?: number | null;
  isLoading?: boolean;
  onClick: () => void;
}

export const ReviewButton = ({
  has_review_event,
  total_count,
  review_prediction_rating,
  isLoading,
  onClick,
}: ReviewButtonProps) => {
  const isVisiblePredictionBadge = !isLoading && !has_review_event && review_prediction_rating;
  const isVisibleReviewCount = !isLoading && !review_prediction_rating;

  return (
    <ReviewWrapper onClick={onClick}>
      <BaseText variation='BODY_13_BOLD' className='review_text'>
        <IconStarSolid width={16} height={16} v3Color='yellow300' />
        &nbsp;리뷰
        {has_review_event && (
          <EventBadge variation='CAPTION_9_MEDIUM' color={white}>
            이벤트
          </EventBadge>
        )}
      </BaseText>
      {isLoading && <LoadingBox />}
      {isVisiblePredictionBadge && <StyledBadge>{review_prediction_rating?.toFixed(1)}점 예측</StyledBadge>}
      {isVisibleReviewCount && (
        <BaseText
          variation='CAPTION_12_REGULAR'
          color={themeTokens.v3Color.gray400.value.light}
          data-custom-ta-key={PDPCustomAttributeKeys.PDP_BOTTOM_REVIEW_COUNT_3}
          css={css`
            width: 56px;
            text-align: center;
          `}
        >
          ({numberWithPlusSignByMaxCount(total_count, 99999)})
        </BaseText>
      )}
    </ReviewWrapper>
  );
};

const ReviewWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-right: 12px;
  cursor: pointer;

  .review_text {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    white-space: nowrap;
  }
`;

const EventBadge = styled(BaseText)`
  margin-left: 2px;
  padding: 2px 3px;
  border-radius: 100px;
  line-height: normal;
  background-color: ${vars.v3Color.purple400};
`;

const StyledBadge = styled(Badge)`
  background-color: rgba(143, 130, 255, 0.1);
  color: ${vars.v3Color.purple500};
`;

const LoadingBox = styled.div`
  width: 58px;
  height: 18px;
`;
